const EMPTY_VALUE = ' ';

function LocalizeDateFilter(config) {
    return function(input, format = 'short', showTime = true) {
        const locale = window.navigator.userLanguage || window.navigator.language || 'en';
        const timezone = config.timezone;

        const dateFormat = config.dateFormats[format];
        const timeFormat = showTime ? 'datetime' : 'date';

        const date = moment.utc(input);

        if(!date.isValid()) {
            return EMPTY_VALUE;
        }

        date.locale(locale);
        date.tz(timezone);

        return date.format(dateFormat[timeFormat]);
    };
}

LocalizeDateFilter.$inject = ['config'];

module.exports = LocalizeDateFilter;


// WEBPACK FOOTER //
// ./src/azurebackup/filters/localizeDate.filter.js